import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';

/**
 * Props for `LogoStrip`.
 */
export type LogoStripProps = SliceComponentProps<Content.LogoStripSlice>;

/**
 * Component for "LogoStrip" Slices.
 */
const LogoStrip = ({ slice }: LogoStripProps): JSX.Element => {
  const {
    primary: { heading, logos },
  } = slice;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      style={{
        backgroundColor: '#F3F3F8',
      }}
      className="container-mx-auto"
    >
      <div className="container mx-auto p-5 text-white h-full w-full flex text-center justify-center items-center">
        <div className="flex flex-row items-center mx-auto">
          <div
            className="flex flex-col text-left max-w-[11rem] mr-16"
            style={{
              color: '#666666',
              fontWeight: '700',
              lineHeight: '140%',
              fontSize: '20px',
            }}
          >
            <PrismicRichText field={heading} />
          </div>
          <div className="flex flex-row flex-nowrap overflow-x-auto no-scrollbar items-center gap-x-7 mx-auto">
            {logos.map((item, index) => (
              <div key={`leader-logo-${index}`} className="flex-shrink-0">
                <PrismicNextImage field={item.logo_image} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoStrip;
